import React, { useState, useEffect } from 'react';

interface RippleProps {
  color?: string;
}

const RippleEffect: React.FC<RippleProps> = ({ color = 'rgba(255, 255, 255, 0.7)' }) => {
  const [ripples, setRipples] = useState<{ id: number; x: number; y: number }[]>([]);

  useEffect(() => {
    // Clean up ripples after animation
    const timer = setInterval(() => {
      setRipples((prevRipples) => prevRipples.slice(1));
    }, 600);

    return () => clearInterval(timer);
  }, []);

  const createRipple = (e: React.MouseEvent<HTMLDivElement>) => {
    const button = e.currentTarget;
    const rect = button.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setRipples([...ripples, { id: Date.now(), x, y }]);
  };

  return (
    <div 
      className="absolute inset-0 overflow-hidden pointer-events-none"
      onClick={createRipple}
    >
      {ripples.map((ripple) => (
        <div
          key={ripple.id}
          className="absolute animate-ripple rounded-full"
          style={{
            left: ripple.x,
            top: ripple.y,
            width: 10,
            height: 10,
            backgroundColor: color,
            transform: 'translate(-50%, -50%)',
          }}
        />
      ))}
    </div>
  );
};

export default RippleEffect;